import { Navigate } from 'react-router-dom';

import { useHasConnectedEnvironment } from '@oneclick/hooks/useHasConnectedEnvironment';

import { SuspenseLoader } from 'components/loaders';

export const ClusterGate = () => {
  const { isLoading, hasConnectedEnvironment, isStatusUnknown } =
    useHasConnectedEnvironment();

  if (isLoading || isStatusUnknown) {
    return <SuspenseLoader />;
  }

  return hasConnectedEnvironment ? (
    <Navigate to="/clusters" replace />
  ) : (
    <Navigate to="/onboarding" replace />
  );
};
